// extracted by mini-css-extract-plugin
export default {"buttonCross":"DeleteButton_buttonCross__Sv3mJ","iconCross":"DeleteButton_iconCross__YdEcV"};